import { RequestState } from "../types/requestState";

function resetRequestState(): RequestState {
  return {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  };
}

export { resetRequestState };
